/**
 * Đường dẫn GỐC mà Nhật ký sử dụng AI trỏ ra ngoài. Component bọc bằng `useDuongDan()` (`hooks/useDuongDan.ts`) để có
 * tiền tố cổng, không viết thẳng `/client/...` hay `/admin/...`.
 */

/**
 * Lối xử lý lượt "chưa có giá" và "thiếu tỷ giá": giá và tỷ giá AI do nền tảng quản lý (tab "Bảng giá model" của Gói &
 * thanh toán, ADR-0095 mục 10), nên chỉ cổng nền tảng có lối này; tenant chỉ thấy nhãn.
 */
export const DUONG_BANG_GIA_NEN_TANG = '/goi-thanh-toan?tab=bang-gia-model';
